var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_vm._t("default",function(){return [_vm._v("Партнёры")]})],2),_c('section',{attrs:{"id":"partners"}},_vm._l((_vm.sortedList),function(item,index){return _c('a',{key:index,staticClass:"partners_item",attrs:{"href":item.url}},[_c('img',{attrs:{"src":`${_vm.$store.getters.getUrlApi}${item.img}`,"alt":item.title}})])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }